import React from "react"
import * as SVG from "./tabNavBarIcons"

const iconsMap = [
  { "iconTitle": "Home", "iconSvg": SVG.HomeIcon },
  { "iconTitle": "news-clap", "iconSvg": SVG.NewsClap },
  { "iconTitle": "Show", "iconSvg": SVG.ShowIcon },
  { "iconTitle": "Movie", "iconSvg": SVG.MovieIcon },
  { "iconTitle": "Plan", "iconSvg": SVG.PlansIcon },
  { "iconTitle": "Genre", "iconSvg": SVG.GenreIcon },
  { "iconTitle": "Article", "iconSvg": SVG.ArticleIcon },
  { "iconTitle": "Collection", "iconSvg": SVG.CollectionIcon },
  { "iconTitle": "Categories", "iconSvg": SVG.CategoryIcon },
  { "iconTitle": "Music", "iconSvg": SVG.MusicIcon },
  { "iconTitle": "Live", "iconSvg": SVG.LiveIcon },
  { "iconTitle": "Language", "iconSvg": SVG.LanguageIcon },
  { "iconTitle": "Menu", "iconSvg": SVG.MenuIcon },
  { "iconTitle": "Play", "iconSvg": SVG.PlayIcon },
  { "iconTitle": "Bracket", "iconSvg": SVG.BracketIcon },
  { "iconTitle": "Search", "iconSvg": SVG.SearchIcon },
  { "iconTitle": "Shop", "iconSvg": SVG.ShopIcon },
  { "iconTitle": "Grid", "iconSvg": SVG.GridIcon },
  { "iconTitle": "Subscription", "iconSvg": SVG.SubscriptionIcon },
  { "iconTitle": "Faq", "iconSvg": SVG.FaqIcon },
  { "iconTitle": "Watchlist", "iconSvg": SVG.WatchListIcon },
  { "iconTitle": "Clock", "iconSvg": SVG.ClockIcon },
  { "iconTitle": "Gear", "iconSvg": SVG.GearIcon },
  { "iconTitle": "User", "iconSvg": SVG.UserIcon },
  { "iconTitle": "Contact", "iconSvg": SVG.ContactIcon },
  { "iconTitle": "Account", "iconSvg": SVG.AccountIcon },
  { "iconTitle": "At", "iconSvg": SVG.AtIcon },
  { "iconTitle": "CC", "iconSvg": SVG.CCIcon },
  { "iconTitle": "SignIn", "iconSvg": SVG.SignInIcon },
  { "iconTitle": "SignOut", "iconSvg": SVG.SignOutIcon },
  { "iconTitle": "About", "iconSvg": SVG.AboutIcon },
  { "iconTitle": "Privacy", "iconSvg": SVG.PrivacyIcon },
  { "iconTitle": "Terms", "iconSvg": SVG.TermsIcon },
  { "iconTitle": "SignUp", "iconSvg": SVG.SignUpIcon },
  { "iconTitle": "Experience", "iconSvg": SVG.ExperienceIcon },
  { "iconTitle": "Browse", "iconSvg": SVG.BrowseIcon },
  { "iconTitle": "Saved", "iconSvg": SVG.SavedIcon },
  { "iconTitle": "Tick", "iconSvg": SVG.TickIcon },

  { "iconTitle": "watching", "iconSvg": SVG.watching },
  { "iconTitle": "termconditions", "iconSvg": SVG.termconditions },
  { "iconTitle": "settings", "iconSvg": SVG.settings },
  { "iconTitle": "ppolicy", "iconSvg": SVG.ppolicy },
  { "iconTitle": "parental_control", "iconSvg": SVG.parental_control },
  { "iconTitle": "logout", "iconSvg": SVG.logout },
  { "iconTitle": "lang1", "iconSvg": SVG.lang1 },
  { "iconTitle": "history", "iconSvg": SVG.history },
  { "iconTitle": "help", "iconSvg": SVG.help },
  { "iconTitle": "generees", "iconSvg": SVG.generees },
  { "iconTitle": "favourites", "iconSvg": SVG.favourites },
  { "iconTitle": "download", "iconSvg": SVG.download },
  { "iconTitle": "chat", "iconSvg": SVG.chat },
  { "iconTitle": "ab_us", "iconSvg": SVG.ab_us },
  { "iconTitle": "refer-earn", "iconSvg": SVG.refer_earn },
  { "iconTitle": "record", "iconSvg": SVG.record },
  { "iconTitle": "contentFilter", "iconSvg": SVG.contentFilter },
]

export const iconsToShow = (primary, color, id) => {
  const returnedIconsArray = iconsMap.map(({ iconTitle, iconSvg: Svg }, index) => {
    return (primary.icon && (primary.icon).toLowerCase().includes("icon-"+iconTitle.toLowerCase()) && <Svg key={index} color={color} id={id} url={primary.url} />)
  })

  const filteredIconArray = returnedIconsArray.filter((icon) => { return icon !== false })
  return filteredIconArray.length === 1 ? filteredIconArray : <div className="div-height"></div>
}

export const showLogoutIcon = (logoutIcon) => {
  if(!logoutIcon) return false;

  return iconsMap.map(({ iconTitle, iconSvg: Svg }, index) => {
    return (logoutIcon && logoutIcon.toLowerCase().includes("icon-"+iconTitle.toLowerCase()) && <Svg key={index} />)
  })
}